var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHcChatIcon = function SvgHcChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6752 8.999C11.6794 8.999 8.4288 11.5398 8.4288 14.6618C8.4288 16.312 9.3374 17.7988 10.783 18.8338C10.7723 18.8338 10.7616 18.8342 10.7508 18.8347C10.7401 18.8351 10.7292 18.8356 10.7184 18.8356C9.3242 18.8356 8.008 18.5844 6.8388 18.1382L3.9698 20.0152L4.6064 16.9212C2.9986 15.7118 2 14.0298 2 12.1678C2 8.4852 5.903 5.5 10.7184 5.5C14.3064 5.5 17.3874 7.1576 18.726 9.5278C17.7978 9.1884 16.7646 8.999 15.6752 8.999ZM15.7784 10.0228C19.2098 10.0228 22 12.1042 22 14.6618C22 16.0438 21.1824 17.3302 19.7518 18.219L20.0462 20.1746L18.0568 18.9746C17.3264 19.1902 16.5604 19.3008 15.7784 19.3008C12.347 19.3008 9.555 17.2196 9.555 14.6618C9.555 12.1042 12.347 10.0228 15.7784 10.0228Z",
    fill: "currentColor"
  })));
};
export default SvgHcChatIcon;